import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyD4V_Ycy8Nqmm4tRQ85jEuKLLunMnEfgQo",
    authDomain: "warehouse-management-394912.firebaseapp.com",
    projectId: "warehouse-management-394912",
    storageBucket: "warehouse-management-394912.appspot.com",
    messagingSenderId: "950318003585",
    appId: "1:950318003585:web:47bfe8dc96f57c3e0f6480",
    measurementId: "G-GS33QY6P18"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get a Firestore instance
const db = getFirestore(app);

export default db;
